/*
------------------------------------------------
Delishop Framework
Testimonials Delishop
Version: 1.0
Compatible: Shrine Pro 1.5.4
------------------------------------------------
*/

(function () {

    function initTestimonials(section) {

        if (!section) return;

        const rows = section.querySelectorAll(".dh-marquee__row");

        if (!rows.length) return;

        // Pausar la animación cuando la pestaña no está visible
        document.addEventListener("visibilitychange", function () {

            rows.forEach(function (row) {

                row.style.animationPlayState =
                    document.hidden ? "paused" : "running";

            });

        });

    }

    document.addEventListener("DOMContentLoaded", function () {

        document
            .querySelectorAll(".dh-testimonials")
            .forEach(initTestimonials);

    });

    document.addEventListener("shopify:section:load", function (event) {

        const section = event.target.querySelector(".dh-testimonials");

        if (section) {

            initTestimonials(section);

        }

    });

})();